import React from 'react';
import { withTranslation } from 'react-i18next';
import Cookies from 'js-cookie';

import {
  toast,
  withRouter,
  Row,
  Col,
  Axios,
  TEXTFIELD,
  PASSWORDFIELD,
  GoogleAutocomplete,
  SUBMIT,
  RESET,
  ApiUrl,
  checkValidations,
  checkError,
  CircularProgress,
  CHECKBOX,
  SELECT,
  connect,
  PHONECODES,
} from '../components';

import { PASS_REGEX } from '../ApiUrl';
import { PROVINCES } from '../constants/provinces';

import {
  hideMessage,
  showAuthLoader,
  userSignInSuccess,
  hideAuthLoader,
} from 'actions/Auth';

const {
  EMAIL_REGEX,
  PASS_VALIDATION_MSG,
  US_NUMERIC_WITH_OR_WITHOUT_PLUS_AT_START,
  API_ADD_STORES,
  API_EDIT_STORES,
  API_GET_CATEGORY_URL,
} = ApiUrl;

class SignIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      editId: this.props.editId,
      process: this.props.role,
      imagePreviewUrl: '',
      details: this.props.details,
      loading: false,
      categoriesList: [],
      cuisinesList: [],
      name: '',
      vendorName: '',
      email: '',
      country: '',
      mobileNumber: '',
      countryCode: '+1',
      province: '',
      address: '',
      lng: '',
      lat: '',
      cuisines: [],
      selectedOption: [],
      categories: [],
      images: {},
      businessproof: {},
      password: '',
      password2: '',
      accreditationNumber: '',
      groupCode: '',
      discription: '',
      errors: {
        name: '',
        email: '',
        vendorName: '',
        country: '',
        city: '',
        address: '',
        lng: '',
        lat: '',
        cuisines: '',
        accreditationNumber: '',
        images: this.props.role !== 'edit' ? '' : '',
        businessproof: this.props.role !== 'edit' ? '' : '',
      },
      disabled: true,
    };
  }

  handleCheck = (event) => {
    this.setState({ checked: event.target.checked });
  };

  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let finalVal = value;
    let errors = this.state.errors;

    switch (name) {
      case 'name':
        errors.name = value.length < 1 ? this.props.t('auth.errors.required') : '';
        break;
      case 'vendorName':
        errors.vendorName = value.length < 1 ? this.props.t('auth.errors.required') : '';
        break;
      case 'email': {
        let err = '';
        if (value.length < 1) {
          err = this.props.t('auth.errors.required');
        } else if (!EMAIL_REGEX.test(value)) {
          err = this.props.t('auth.errors.invalidEmail');
        }
        errors.email = err;
        break;
      }
      case 'password': {
        let err = '';
        if (value.length < 1) {
          err = this.props.t('auth.errors.required');
        } else if (!PASS_REGEX.test(value)) {
          err = this.props.t('auth.errors.invalidPassword');
        }
        errors.password = err;
        if (this.state.password2 && this.state.password2 !== value) {
          errors.password2 = this.props.t('auth.errors.passwordMismatch');
        } else if (this.state.password2) {
          errors.password2 = '';
        }
        break;
      }
      case 'password2': {
        let err = '';
        if (value.length < 1) {
          err = this.props.t('auth.errors.required');
        } else if (this.state.password !== value) {
          err = this.props.t('auth.errors.passwordMismatch');
        }
        errors.password2 = err;
        break;
      }
      case 'mobileNumber': {
        let err = '';
        if (value.length < 1) {
          err = this.props.t('auth.errors.required');
        } else if (!US_NUMERIC_WITH_OR_WITHOUT_PLUS_AT_START.test(value.replace('+1', ''))) {
          err = this.props.t('auth.errors.invalidPhone');
        }
        errors.mobileNumber = err;
        break;
      }
      case 'accreditationNumber':
        errors.accreditationNumber = value.length < 1 ? this.props.t('auth.errors.required') : '';
        break;
      case 'address':
        errors.address = value.length < 1 ? this.props.t('auth.errors.required') : '';
        break;
      case 'categories':
        errors.categories = value.length < 1 ? this.props.t('auth.errors.required') : '';
        break;
      default:
        break;
    }

    this.setState({ errors, [name]: finalVal }, () => {
      let err = checkError(errors);
      this.setState({ disabled: err.disabled });
    });
  };

  redirectPage = () => {
    this.props.history.push('/');
  };

  handleAddress = (address) => {
    let errors = this.state.errors;
    errors.address = !address.address || address.address.length < 1 ? this.props.t('auth.errors.required') : '';
    address.errors = errors;
    this.setState(address);
  };

  handleSubmit = (event) => {
    const { t } = this.props;
    event.preventDefault();

    if (!this.state.checked) return toast.error(t('auth.signup.acceptTerms'));

    this.setState({ loading: true, disabled: true });

    const {
      name,
      email,
      mobileNumber,
      countryCode,
      province,
      address,
      lng,
      lat,
      images,
      password,
      password2,
      editId,
      process,
      accreditationNumber,
      groupCode,
    } = this.state;

    let data = {
      name,
      email,
      mobileNumber,
      address,
      province,
      lat,
      lng,
      password,
      password2,
      countryCode,
      accreditationNumber,
    };

    const valid = checkValidations(data);
    if (valid.error) {
      toast.error(valid.error);
      this.setState({ loading: false, disabled: false });
      return false;
    }

    data = { ...valid.data, groupCode };

    if (images.name !== undefined) {
      data.profileImage = images;
    }

    let url = API_ADD_STORES;
    if (process === 'edit') {
      data.storeid = editId;
      url = API_EDIT_STORES;
    }

    const formData = new FormData();
    for (const key in data) {
      formData.append(key, data[key]);
    }

    Axios.post(url, formData)
      .then((res) => {
        let data = res.data;
        if (data.status === 'failure') {
          toast.error(data.message);
          this.setState({ loading: false, disabled: false });
          return;
        }

        data = data.data;

        Cookies.set('token', data.token);
        Cookies.set('_id', data._id);
        Cookies.set('name', data.name);
        Cookies.set('role', data.role);
        Cookies.set('categories', data.categories[0]);
        Cookies.set('user_id', data.token);
        Cookies.set('restaurantStatus', data.restaurantStatus);
        Cookies.set('featureAccess', data.featureAccess);
        Cookies.set('province', data.province);

        this.props.userSignInSuccess(data.token);

        toast.success(t('auth.signup.success'));

        setTimeout(() => {
          this.redirectPage();
        }, 1000);
      })
      .catch(() => {
        toast.error(t('auth.errors.generic'));
        this.setState({ loading: false, disabled: false });
      });
  };

  reset = () => {
    this.setState({
      name: '',
      vendorName: '',
      email: '',
      country: '',
      mobileNumber: '',
      countryCode: '+1',
      province: '',
      address: '',
      lng: '',
      lat: '',
      discription: '',
      cuisines: [],
      categories: [],
      images: {},
      password: '',
      password2: '',
      accreditationNumber: '',
      groupCode: '',
      businessproof: {},
      errors: {
        name: '',
        vendorName: '',
        email: '',
        country: '',
        province: '',
        address: '',
        lng: '',
        lat: '',
        cuisines: '',
        categories: '',
        images: this.props.role !== 'edit' ? 'Required' : '',
      },
      disabled: true,
    });
  };

  render() {
    const { t } = this.props;
    const {
      name,
      email,
      mobileNumber,
      countryCode,
      province,
      address,
      lng,
      lat,
      password,
      password2,
      errors,
      disabled,
      loading,
      accreditationNumber,
      groupCode,
    } = this.state;

    return (
      <div className="app-signup-content">
        {loading && (
          <div className="loader-view">
            <CircularProgress />
          </div>
        )}
        <form onSubmit={this.handleSubmit} noValidate>
          <Row>
            <Col md="12" xs="12">
              <Row>
                <Col md="6" xs="12">
                  <TEXTFIELD label={t('auth.signup.name')} value={name} name="name" onChange={this.handleChange} errors={errors} />
                </Col>

                <Col md="6" xs="12">
                  <TEXTFIELD label={t('auth.signup.email')} value={email} name="email" onChange={this.handleChange} errors={errors} />
                </Col>

                <Col md="6" xs="12">
                  <TEXTFIELD label={t('auth.signup.phone')} value={mobileNumber} name="mobileNumber" onChange={this.handleChange} errors={errors} />
                </Col>

                <Col md="6" xs="12">
                  <TEXTFIELD
                    label={t('auth.signup.accreditationNumber')}
                    value={accreditationNumber}
                    name="accreditationNumber"
                    onChange={this.handleChange}
                    errors={errors}
                  />
                </Col>

                <Col md="6">
                  <GoogleAutocomplete
                    label={t('auth.signup.address')}
                    address={address}
                    lat={lat}
                    lng={lng}
                    errors={errors}
                    name="address"
                    onChange={this.handleAddress}
                  />
                </Col>

                <Col md="6" xs="12">
                  <SELECT
                    label={t('auth.signup.province')}
                    value={province}
                    all={true}
                    name="province"
                    data={PROVINCES}
                    errors={errors}
                    onChange={this.handleChange}
                  />
                </Col>

                <Col md="6" xs="12">
                  <TEXTFIELD
                    label={t('auth.signup.groupCode')}
                    value={groupCode}
                    name="groupCode"
                    onChange={this.handleChange}
                    errors={errors}
                  />
                </Col>

                <Col md="6" xs="12">
                  <PASSWORDFIELD
                    label={t('auth.signup.password')}
                    value={password}
                    name="password"
                    onChange={this.handleChange}
                    note={t('auth.signup.passwordNote')}
                    errors={errors}
                  />
                </Col>

                <Col md="6" xs="12">
                  <PASSWORDFIELD
                    label={t('auth.signup.confirmPassword')}
                    value={password2}
                    name="password2"
                    onChange={this.handleChange}
                    note={t('auth.signup.passwordNote')}
                    errors={errors}
                  />
                </Col>
              </Row>

              <Row>
                <Col md="6" xs="12">
                  <CHECKBOX
                    name="tos"
                    labelPlacement="end"
                    value={this.state.checked}
                    onChange={this.handleCheck}
                    label={
                      <span>
                        {t('auth.signup.accept')}{' '}
                        <a href="https://meds-on-wheels.com/terms-of-service/" target="_blank" rel="noopener noreferrer">
                          {t('auth.signup.terms')}
                        </a>
                      </span>
                    }
                  />
                </Col>
              </Row>

              <Row>
                <Col md="6" xs="12">
                  <SUBMIT style={{ backgroundColor: disabled ? 'grey' : 'green', color: 'white' }} title={t('auth.signup.submit')} disabled={disabled} />
                </Col>
                <Col md="6" xs="12">
                  <RESET onClick={this.reset} />
                </Col>
              </Row>
            </Col>
          </Row>
        </form>
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const { loader, alertMessage, showMessage, authUser } = auth;
  return { loader, alertMessage, showMessage, authUser };
};

export default connect(mapStateToProps, {
  hideMessage,
  showAuthLoader,
  userSignInSuccess,
  hideAuthLoader,
})(withRouter(withTranslation()(SignIn)));
